import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CHECKOUT_KEY, CHECKOUT_KEY_POS, API_BASE_KEY, CEUMA_URL_CHECKOUT } from 'app/config';

import { Checkout, CheckoutConfig } from 'models/checkout';

const URL_CONFIGURACAO = CEUMA_URL_CHECKOUT + '/configuracoes/recuperarConfiguracoes';
const URL_REALIZAR_PAGAMENTO = CEUMA_URL_CHECKOUT + '/pagamento/realizarPagamento';

@Injectable()
export class CheckoutService {

  constructor(private http: HttpClient) { }

  getConfiguracoes(idSistema: number): Observable<CheckoutConfig[]> {
    return this.http.get<CheckoutConfig[]>(`${URL_CONFIGURACAO}/${idSistema}`);
  }

  efetuaPagamento(checkout: Checkout): Observable<any> {
    switch (checkout.sistema.codigoSistema) {
      case 1:
        checkout.token = API_BASE_KEY;
        break;
      case 2: case 4:
        checkout.token = CHECKOUT_KEY;
        break;
      case 5:
        checkout.token = CHECKOUT_KEY_POS;
        break;
      default:
        break;
    }
    return this.http.post(URL_REALIZAR_PAGAMENTO, checkout);
  }
}
